import { useMutation, useQuery } from 'react-apollo';

import { albumUpdate as albumUpdateMutation } from '../../../../graphql/mutations/albums';
import { AlbumForGreenScreenCheck } from '../../../../graphql/queries/albums';

const useAlbumGreenScreenUploadCheck = ({ albumId }) => {
  const { data: { album } = {}, loading } = useQuery(AlbumForGreenScreenCheck, {
    variables: {
      id: albumId,
    },
    skip: !albumId,
    fetchPolicy: 'network-only',
  });
  const [albumUpdate] = useMutation(albumUpdateMutation);

  const onAlbumUpdate = async input => {
    const result = await albumUpdate({
      variables: {
        input,
      },
    });

    return result;
  };

  return {
    loading,
    onAlbumUpdate,
    includeGreenScreenCheck:
      album?.photos?.total === 0 &&
      album?.root_album_folder?.green_screen_enabled,
  };
};

export default useAlbumGreenScreenUploadCheck;
